import { Status } from "../../models/Status";

export const MARK_DOWN_STATUS = "MARK_DOWN_STATUS";
export const MARK_DOWN_DATA = "MARK_DOWN_DATA";

export type IState = {
  status: Status;
  data: string;
};
